import { SocketEvent } from "../SocketEvent";
import { SocketEventInterface } from "../SocketEventInterface";
import { SocketEventProcessorInterface } from "../SocketEventProcessorInterface";
import Constants from "../../Action/Constants";
import UnitFactory from "../../Entity/Factories/UnitFactory";
import { UnitInterface } from "../../Entity/Entities/Unit/UnitInterface";

class UnitCreate extends SocketEvent implements SocketEventInterface {

  protected props: any;

  constructor() {
    super();
  }

  public process(props: SocketEventProcessorInterface): void {
    const unit: UnitInterface = UnitFactory.create(props.res);
    
    this.props.dispatch({
      type: Constants.GLOBAL_UNIT_CREATE_SUCCESS,
      payload: {
        unit: unit
      }
    });
  }

}

export { UnitCreate };
